export default {
  'processPortal.title': 'Gestionar Portal de Procesos',

  'processPortal.form.id': 'ID',
  'processPortal.form.enable': 'Habilitar',
  'processPortal.form.name': 'Nombre',
  'processPortal.form.description': 'Descripción',
  'processPortal.form.shortenedUrl': 'Url Abreviada',
  'processPortal.form.openUrl': 'Abrir Url',
  'processPortal.form.statusLabel': '¿Elemento Habilitado?',
  'processPortal.form.detailStatus': '¿Habilitado?',

  'processPortal.enabled': 'Habilitado',
  'processPortal.disabled': 'Deshabilitado',

  'processPortal.tblOrder': 'Orden',
  'processPortal.tblProcess': 'Nombre de Proceso',
  'processPortal.form.order': 'Orden del Proceso',
  'processPortal.form.selectProcess': 'Seleccione un Proceso',
  'processPortal.form.exist': 'Proceso ya existe',
  'processPortal.config.publicUrl': 'Url Pública',
  'processPortal.config.disabled': 'Url deshabilitada',
  'processPortal.config.activate': 'Activar Url',
  'processPortal.config.desactivate': 'Desactivar Url',
  'processPortal.config.open': 'Abrir Url',
  'processPortal.form.shortCode': 'ShortCode',

  'processPortal.searchConfig': 'Search',

  'processPortal.titleProcess': 'Configurar Procesos',
  'processPortal.descriptionProcess': 'Configurar los procesos que van a aparecer en el portal',
  'processPortal.titleReport': 'Configurar Reportes',
  'processPortal.descriptionReport': 'Configurar los reportes que van a aparecer en el portal',
  'processPortal.titlePermission': 'Configurar Permisos',
  'processPortal.descriptionPermission': 'Configurar los permisos de acceso al portal',
  'processPortal.titleList': 'Configurar Listas',
  'processPortal.descriptionList': 'Configurar las listas que van a aparecer en el portal',
  'processPortal.titleEntity': 'Configurar Entidades',
  'processPortal.descriptionEntity': 'Configurar las entidades que van a aparecer en el portal',
  'processPortal.titleMenu': 'Configurar Menú',
  'processPortal.descriptionMenu': 'Configurar estructura del menú para el portal de proceso',

  'processPortal.selected.config-process': 'Procesos',
  'processPortal.selected.config-report': 'Reportes',
  'processPortal.selected.config-permission': 'Permisos',
  'processPortal.selected.config-list': 'Listas',
  'processPortal.selected.config-entity': 'Entidades',
  'processPortal.selected.config-menu': 'Menú',

  'processPortal.title.config-process': 'Configurar Procesos',
  'processPortal.title.config-report': 'Configurar Reportes',
  'processPortal.title.config-permission': 'Configurar Permisos',
  'processPortal.title.config-list': 'Configurar Listas',
  'processPortal.title.config-entity': 'Configurar Entidades',
  'processPortal.title.config-menu': 'Configurar Menú',

  'processPortal.options.template.basic': 'Básico',

  'processPortal.form.mainColor': 'Color Principal',
  'processPortal.form.logoUrl': 'Logo (Url)',
  'processPortal.form.template': 'Plantilla',
  'processPortal.form.loginSplashUrl': 'Inicio de Sesión (Url)',
  'processPortal.form.fontUrl': 'Fuente (Url)',
  'processPortal.form.iconLogoUrl': 'Icono (Url)',
  'processPortal.form.faviconUrl': 'Favicon (Url)',
  'processPortal.form.permissionsFiltersLogicalOperator': 'Operador Lógico de Filtros de Permisos',

  'processPortal.menu.customList': 'Lista',
  'processPortal.menu.customLists': 'Todas las Listas',
  'processPortal.menu.dynamicEntity': 'Entidad Dinámica',
  'processPortal.menu.dynamicEntities': 'Todas las Entidades Dinámicas',
  'processPortal.menu.report': 'Reporte',
  'processPortal.menu.reports': 'Todos los Reportes',
  'processPortal.menu.process': 'Proceso',
  'processPortal.menu.processes': 'Todos los Procesos',
  'processPortal.menu.link': 'Enlace',
  'processPortal.menu.subMenu': 'Menú Desplegable',
  'processPortal.menu.embedHtml': 'HTML Incrustado',
  'processPortal.menu.parentSubMenu': 'Sub Menú Padre',
  'processPortal.menu.type': 'Tipo',
  'processPortal.menu.htmlFile': 'Archivo HTML',
  'processPortal.menu.preview': 'Vista Previa',

  'processPortal.action.generatePublicUrl': 'Generar URL Pública',
  'processPortal.action.deactivatePublicUrl': 'Desactivar URL Pública',
};
